module.exports = __webpack_public_path__ + "img/man.dba7f6be.png";